import { Reveal, SectionHead } from "./Reveal";

const WORK = [
  {
    tag: "Brand Ad",
    title: "Spec Commercial — Streetwear Label",
    img: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Creative portrait under hard light",
    span: "lg:col-span-7",
  },
  {
    tag: "Music Video",
    title: "Performance Film — Indie Artist",
    img: "https://images.unsplash.com/photo-1576280314550-773c50583407?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Silhouette performing on set",
    span: "lg:col-span-5",
  },
  {
    tag: "Fashion Film",
    title: "Experimental Editorial — Cohort 01",
    img: "https://images.unsplash.com/photo-1620122303020-87ec826cf70d?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Studio portrait with dramatic shadow",
    span: "lg:col-span-5",
  },
  {
    tag: "AI Campaign",
    title: "Hybrid Spot — Product Launch",
    img: "https://images.unsplash.com/photo-1565626424178-c699f6601afd?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Brutalist architecture with light shaft",
    span: "lg:col-span-7",
  },
];

export const RealWork = () => (
  <section data-testid="real-work-section" className="bg-obsidian py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="07" eyebrow="Not Exercises" title="Real work. Real stakes." />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {WORK.map((w, i) => (
          <Reveal key={w.title} delay={(i % 2) * 0.12} className={`group ${w.span}`}>
            <div className="relative overflow-hidden border border-line h-[320px] sm:h-[420px]">
              <img src={w.img} alt={w.alt} className="img-cine w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-transparent to-transparent" />
              <div className="absolute inset-0 bg-acid/0 group-hover:bg-acid/10 transition-colors duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
                <div>
                  <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-acid">{w.tag}</span>
                  <p className="font-head text-lg sm:text-xl font-semibold uppercase tracking-tight text-cream mt-2">{w.title}</p>
                </div>
                <span className="font-mono text-[10px] text-dim">0{i + 1}</span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
